import { render, staticRenderFns } from "./shopRecord.vue?vue&type=template&id=17a8dd6e&scoped=true"
import script from "./shopRecord.vue?vue&type=script&lang=js"
export * from "./shopRecord.vue?vue&type=script&lang=js"
import style0 from "./shopRecord.vue?vue&type=style&index=0&id=17a8dd6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a8dd6e",
  null
  
)

export default component.exports